const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "MOVIE_CATEGORY_MOVIES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "MOVIE_CATEGORY_MOVIES_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "MOVIE_CATEGORY_MOVIES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
